var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.chatList),function(dialogue,index){return _c('div',{key:index},[(dialogue.role === 'assistant')?_c('ChatLeft',{attrs:{"dialogue":dialogue}}):_vm._e(),(dialogue.role === 'user')?_c('ChatRight',{attrs:{"dialogue":dialogue,"index":index}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }